import type { DocMeta } from "./meta.ts";

/**
 * Who a document is written for: Klarity's own people, or a client. It says nothing about the subject or the
 * place: an internal document can be about one client and sit in that client's space.
 */
export type Audience = NonNullable<DocMeta["audience"]>;

/** The one list: its order is the order of the two groups of templates on screen, and its headings name them. */
export const AUDIENCES: readonly { key: Audience; heading: string }[] = [
  { key: "internal", heading: "Internal" },
  { key: "client", heading: "Client-facing" },
];

/** A meta without an audience is internal, as `resolveMeta` has it. */
export const audienceOf = (meta: Pick<DocMeta, "audience"> | null | undefined): Audience =>
  meta?.audience === "client" ? "client" : "internal";
